module.exports = __webpack_public_path__ + "img/16_99.26375f77.png";